import { ethers } from "ethers";

export default function EnsUtils(rpcUrl) {
  const ethersProvider = new ethers.providers.JsonRpcProvider(rpcUrl);

  return {
    async getMainENS(address) {
      return await ethersProvider.lookupAddress(address);
    },
  };
}
